var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "处理",
        visible: _vm.dialogVisible,
        width: "600px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ticketHandleForm",
          attrs: {
            model: _vm.ticketHandleForm,
            rules: _vm.ticketHandleRules,
            "label-width": "auto",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "is-required",
              attrs: { label: "工单状态：", prop: "status" },
            },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.ticketHandleForm.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.ticketHandleForm, "status", $$v)
                    },
                    expression: "ticketHandleForm.status",
                  },
                },
                [
                  _c("el-checkbox", { attrs: { label: 30 } }, [
                    _vm._v("已解决"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "说明：" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: 300,
                  "show-word-limit": "",
                  placeholder: "请输入...",
                },
                model: {
                  value: _vm.ticketHandleForm.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.ticketHandleForm, "remark", $$v)
                  },
                  expression: "ticketHandleForm.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.ticketHandleLoading },
              on: { click: _vm.submitTicketHandle },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }